import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEn from '@app/locales/en';
import translationTh from '@app/locales/th';

i18n.use(initReactI18next).init({
  lng: 'EN',
  resources: {
    EN: {
      translation: translationEn,
    },
    TH: {
      translation: translationTh,
    },
  },
  fallbackLng: 'EN',
  debug: process.env.NODE_ENV !== 'production',
});

export default i18n;
